::ng-deep lib-library-content{display:flex;width:100%;height:100%}::ng-deep lib-library-content .pos-relative{height:initial}::ng-deep particle-document-viewer{display:flex;width:100%;height:100%}
/*# sourceMappingURL=library-content.component-7B5NUMJJ.css.map */
